import { createReducer } from '@reduxjs/toolkit';
import { CLOSE_SIDEBAR, OPEN_SIDEBAR } from '../actions/sidebar';

export type SidebarState = {
  open: boolean;
};

const initState: SidebarState = {
  open: false,
};

const sidebarReducer = createReducer(initState, (builder) =>
  builder
    .addCase(OPEN_SIDEBAR, (state) => ({ ...state, open: true }))
    .addCase(CLOSE_SIDEBAR, (state) => ({ ...state, open: false }))
);

export default sidebarReducer;
